<template>
    <div v-if="!isMobile" class="row-block compact-card">
        <ul class="columns-block">
            <li class="column">
                <div class="column-block custom-row">
                    <div v-if="showActsColumnStatus && order.showCheckbox" class="acts-checkbox">
                        <input
                          v-if="order.showCheckbox"
                          :disabled="[6].includes(order.statusId)"
                          :readonly="[6].includes(order.statusId)"
                          type="checkbox" name="akt" :id="'act-'+order.id"
                          @change="aktsToggleCompact(order,$event)"
                          :checked="margeActsList.hasOwnProperty(order.id)"
                        >
                    </div>
                    <div class="col-item">
                        <span class="order-type">
                          <span>{{ showTypeInsurance(order) }}</span>
                        </span>
                        <div class="bottom-block order-status">
                          <div :class="['status', getStatusClass(order)]">
                            <span>{{ showStatusName(order) }}</span>
                          </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                <a class="order-number" target="_blank" :href="showMtsbuLink(order)" v-if="showMtsbuLink(order)">
                  {{ showMtsbuCode(order) }}<br />{{ showMtsbuCodeAdditionalInfo(order) }}
                </a>
                <span v-else-if="showMtsbuCode(order)" class="order-number">
                      {{ showMtsbuCode(order) }}
                    </span>
                <span class="order-number" v-else>&mdash;</span>
                <div class="bottom-block" v-if="order.act && !getParentId()">
                  <span class="dark-link" style="text-decoration: underline;" v-html="showActName(order)"></span>
                </div>
              </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div class="date-block">
                      <div class="text">Створений:</div>
                      <span v-if="order.createdAt" class="date">{{ order.createdAt }}</span>
                      <span v-else class="date">&mdash;</span>
                    </div>
                </div>
            </li>
            <li class="column">
                <div class="column-block">
                <div class="order-insured">
                    <a class="dark-link" v-if="order.client_id" :href="'/clients/'+order.client_id">
                        <div v-if="showNameInsurantSurname(order)">
                          <span>{{ showNameInsurantSurname(order) }}</span>
                          <span> {{ showNameInsurantName(order) }}</span>
                          <span v-if="showNameInsurantPatronymic(order)"> {{ showNameInsurantPatronymic(order) }}</span>
                        </div>
                    </a>
                    <div v-else>
                        <div v-if="showNameInsurantSurname(order)">
                          <span>{{ showNameInsurantSurname(order) }}</span>
                          <span v-if="showNameInsurantName(order)">{{ showNameInsurantName(order) }}</span>
                          <span v-if="showNameInsurantPatronymic(order)">{{ showNameInsurantPatronymic(order) }}</span>
                        </div>
                    </div>
                </div>
              </div>
            </li>
            <li class="column">
                <div class="column-block">
                    <div v-if="showDiscount(order)" class="price-block">
                      <div class="text">Зі знижкою:</div>
                      <span class="date">{{ showAllPrice(order) }}
        <!--                <i class="icon question" data-html="true" data-placement="bottom" data-select="true" data-toggle="tooltip" title="Первісна вартість може бути знижена за рахунок знижки посередника та за рахунок виключення місяців, з періоду дії полісу."></i>-->
                      </span>
                    </div>
                    <div v-else class="price-block">
                      <div class="text">Первісна:</div>
                      <span class="date">{{ showPrice(order) }}</span>
                    </div>
                    <div v-if="order.landingPromoCode" class="price-block">
                      <div class="text">Промокод «{{ order.landingPromoCode }}»:</div>
                      <span class="date">&minus;{{ order.landingPromoAmount }} грн ({{ order.landingPromoPercent }}%)</span>
                    </div>
                </div>
            </li>
            <li class="column">
                <div class="column-block custom-row actions-col">
                    <div v-if="!$store.getters.USER.organizationId || $store.getters.USER.organizationType === 'head'">
                      <!--                    <div class="price-block" v-if="order.allEarnings">-->
                      <!--                      <div :class="['text', {'long' : showTerminated(order)}]">Загальний:</div>-->
                      <!--                      <span class="price">{{ order.allEarnings }}</span>-->
                      <!--                    </div>-->
                      <div class="price-block">
                        <div :class="['text', {'long' : showTerminated(order)}]">Ваш:</div>
                        <span v-if="order.myEarnings" class="earning">{{ order.myEarnings }}</span>
                        <span v-else class="earning">&mdash;</span>
                      </div>
                    </div>
                    <div class="more-actions">
                        <div v-if="loadMoreOptions[order.id + order.typeId] === true"
                             class="option-loader spinner-border"
                             style="height: 14px; width: 14px; margin-bottom: 4px;"
                             role="status">
                        </div>
                        <more-options v-else :status-order="showStatusId(order)"
                                      :order="order"
                                      :order-type="order.typeId"
                                      :data-contract-extra-files="order.contract.extraFiles"
                                      @download-draft="showDraft(order)"
                                      @download-contract="takeContractCompact(order, 1)"
                                      @show-order="goToOrderInfo(order)"
                                      @proceed-order="declare(order,false,false,1)"
                                      @confirm-order="declare(order,false,false,2)"
                                      @open-mtsbu-link="openMtsbuLink(order)"
                                      @get-all-payment-ways="showAllOrderPaymentWays(order)"
                                      @get-payment-invoice="getPaymentInvoice(order)"
                                      @get-instant-loan="getInstantLoan(order)"
                                      :is-exist-mtsbu-link="showMtsbuLink(order)"
                                      @copy-order="copy(order)">
                        </more-options>
                    </div>
                </div>
            </li>
        </ul>

        <!-- Додаткові продукти -->
        <div v-if="order.typeId === 1 && (showDgoPrice(order) || showAutolawyerPrice(order))" class="additional-products">
            <!-- Розділювач пунктиром -->
            <div class="dotted-divider"></div>

            <!-- ДЦВ -->
            <ul v-if="showDgoPrice(order)" class="columns-block additional-product-row">
                <li class="column">
                  <div class="column-block custom-row">
                    <div class="col-item">
                        <span class="order-type">
                          <span class="additional-product-label">ДЦВ</span>
                        </span>
                    </div>
                  </div>
                </li>
                <li class="column">
                  <div class="column-block"></div>
                </li>
                <li class="column">
                  <div class="column-block"></div>
                </li>
                <li class="column">
                  <div class="column-block"></div>
                </li>
                <li class="column">
                  <div class="column-block">
                    <div class="price-block">
                      <div class="text">Первісна:</div>
                      <span class="date">{{ showDgoPrice(order) }}</span>
                    </div>
                  </div>
                </li>
                <li class="column">
                  <div class="column-block"></div>
                </li>
            </ul>

            <!-- Автоюрист -->
            <ul v-if="showAutolawyerPrice(order)" class="columns-block additional-product-row">
                <li class="column">
                  <div class="column-block custom-row">
                    <div class="col-item">
                        <span class="order-type">
                          <span class="additional-product-label">Автоюрист</span>
                        </span>
                    </div>
                  </div>
                </li>
                <li class="column">
                  <div class="column-block"></div>
                </li>
                <li class="column">
                  <div class="column-block"></div>
                </li>
                <li class="column">
                  <div class="column-block"></div>
                </li>
                <li class="column">
                  <div class="column-block">
                    <div class="price-block">
                      <div class="text">Первісна:</div>
                      <span class="date">{{ showAutolawyerPrice(order) }}</span>
                    </div>
                  </div>
                </li>
                <li class="column">
                  <div class="column-block"></div>
                </li>
            </ul>
        </div>

    </div>


    <div v-else class="row order-data compact-card-mobile">
        <div class="col-6">
            <div v-if="showActsColumnStatus && order.showCheckbox" class="acts-checkbox">
                <input
                  v-if="order.showCheckbox"
                  :disabled="[6].includes(order.statusId)"
                  :readonly="[6].includes(order.statusId)"
                  type="checkbox" name="akt" :id="'act-'+order.id"
                  @change="aktsToggleCompact(order,$event)"
                  :checked="margeActsList.hasOwnProperty(order.id)"
                >
            </div>
        </div>

        <div class="row-mobile first-row">
            <div class="col-6 half-block">
              <div class="info-block">
                <div class="option-title">Тип поліса</div>
                <div class="option-value">{{ showTypeInsurance(order) }}</div>
                <div class="bottom-block" v-if="order.act">
                  <span style="text-decoration: underline;font-weight: 700;font-size: 12px;color: black;" v-html="showActName(order)"></span>
                </div>
              </div>
            </div>
            <div class="col-6 half-block">
              <div class="info-block">
                <div class="option-title">Номер поліса</div>
                <div class="option-value mtsbu-value">
                  <a :href="showMtsbuLink(order)" v-if="showMtsbuLink(order)">
                    {{ showMtsbuCode(order) }}
                  </a>
                  <span v-else-if="showMtsbuCode(order)" class="order-number">
                    {{ showMtsbuCode(order) }}
                  </span>
                  <span class="order-number" v-else>&mdash;</span>
                </div>
              </div>
            </div>
        </div>

        <div class="row-mobile">
            <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Страхувальник</div>
                  <a class="dark-link" :href="'/clients/'+order.client_id">
                    <div class="option-value">
                      {{ showNameInsurantSurname(order) }}
                    </div>
                    <div class="option-value">
                      {{ showNameInsurantName(order) }}
                    </div>
                    <div v-if="showNameInsurantPatronymic(order)" class="option-value">
                      {{ showNameInsurantPatronymic(order) }}
                    </div>
                  </a>
                  <div class="option-value">
                    <div class="mb-2">{{ order.insuranceObject.number }}</div>
                  </div>
                </div>
            </div>
            <div class="col-6 half-block">
                <div class="info-block">
                    <div class="option-title">Дата</div>
                    <div class="sub-options">
                      <div>
                        <span class="sub-option-title fixed-width">Створений:</span>
                        <span v-if="order.createdAt" class="option-value">{{ order.createdAt }}</span>
                        <span v-else class="option-value">&mdash;</span>
                      </div>
                      <div>
                        <span class="sub-option-title fixed-width">Початок:</span>
                        <span v-if="showStartedAtContract(order)"
                              class="option-value">{{ showStartedAtContract(order) }}</span>
                        <span v-else class="option-value">&mdash;</span>
                      </div>
                      <div>
                        <span class="sub-option-title fixed-width">Закінчення:</span>
                        <span v-if="showFinishedAtContract(order)"
                              class="option-value">{{ showFinishedAtContract(order) }}</span>
                        <span v-else class="option-value">&mdash;</span>
                      </div>
                      <div v-if="showTerminated(order)">
                        <span class="sub-option-title fixed-width">Дата ДР:</span>
                        <span v-if="showTerminated(order)" class="option-value">{{ showTerminated(order) }}</span>
                      </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row-mobile">
            <div class="col-6 half-block">
                <div class="info-block">
                    <div class="option-title">Вартість, грн</div>
                    <div class="sub-options">
                      <div>
                        <span class="sub-option-title">Первісна:</span>
                        <span class="option-value">{{ showPrice(order) }}</span>
                      </div>
                      <div v-if="showDiscount(order)">
                        <span class="sub-option-title">Зі знижкою:</span>
                        <span class="option-value">{{ showDiscount(order) }}</span>
                      </div>
                      <div v-if="order.landingPromoCode">
                        <span class="sub-option-title">Промокод «{{ order.landingPromoCode }}»:</span>
                        <span class="option-value">&minus;{{ order.landingPromoAmount }} грн ({{ order.landingPromoPercent }}%)</span>
                      </div>
                      <div v-if="showDgoPrice(order)">
                        <span class="sub-option-title">ДЦВ:</span>
                        <span class="option-value">{{ showDgoPrice(order) }}</span>
                      </div>

                      <!--                                        <div class="mt-4 mb-1">-->
                      <!--                                            <span class="sub-option-title">Статус:</span>-->
                      <!--                                            <div :class="['value status', getStatusClass(order)]">-->
                      <!--                                                <span>{{ showStatusName(order) }}</span>-->
                      <!--                                            </div>-->
                      <!--                                                <div v-if="checkOrderPaid(order) && (showStatusId(order) === 5 || order.typeId === 5)" class="payment-status paid mt-1 ml-5"><span>Сплачено</span></div>-->
                      <!--                                                <div v-if="!checkOrderPaid(order) && (showStatusId(order) === 5 || showStatusId(order) === 10)" class="payment-status mt-1 ml-5"><span>Не сплачено</span></div>-->
                      <!--                                        </div>-->

                    </div>
                </div>
            </div>
            <div class="col-6 half-block">
                <div class="info-block">
                    <div class="option-title">Заробіток, грн</div>
                    <div class="sub-options">
                      <div v-if="order.isPartnerOrder">
                        <span class="sub-option-title">Загальний:</span>
                        <span v-if="order.allEarnings" class="option-value">{{ order.allEarnings }}</span>
                        <span v-else class="option-value">&mdash;</span>
                      </div>
                      <div>
                        <span class="sub-option-title">Ваш:</span>
                        <span v-if="order.myEarnings" class="option-value">{{ order.myEarnings }}</span>
                        <span v-else class="option-value">&mdash;</span>
                      </div>
                      <div v-if="order.isPartnerOrder">
                        <span class="sub-option-title">Агента:</span>
                        <span v-if="order.partnerEarnings" class="option-value">{{
                            order.partnerEarnings
                          }}</span>
                        <span v-else class="option-value">&mdash;</span>
                      </div>
                      <div v-if="showTerminated(order)">
                        <span class="sub-option-title">Утримано за ДР:</span>
                        <span class="option-value">{{ showTerminatedSum(order) }}</span>
                      </div>
                    </div>
                </div>
            </div>
        </div>

<!--        <div class="row-mobile">-->
<!--            <div class="col-6 half-block">-->
<!--                <div class="info-block">-->
<!--                <div class="option-title">Статус:</div>-->
<!--                <el-row type="flex" class="mb-1">-->
<!--                  &lt;!&ndash;                                              <el-col :span="6" class="sub-option-title">Статус:</el-col>&ndash;&gt;-->
<!--                  <el-col>-->
<!--                    <div :class="['option-value status w-100', getStatusClass(order)]">-->
<!--                      <span>{{ showStatusName(order) }}</span>-->
<!--                    </div>-->
<!--                    <div v-if="checkOrderPaid(order) && (showStatusId(order) === 5 || order.typeId === 5)">-->
<!--                      <div class="option-value payment-status status paid mt-1 w-100">-->
<!--                        <span>Сплачено</span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div v-if="!checkOrderPaid(order) && (showStatusId(order) === 5 || showStatusId(order) === 10)">-->
<!--                      <div class="option-value payment-status status mt-1 w-100">-->
<!--                        <span>Не сплачено</span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div>&lt;!&ndash; class="col-12 mb-3" v-if="isProlongationOrder(order)" &ndash;&gt;-->
<!--                      <div class="option-value mt-1 w-100" style="margin-top: 8px; margin-left: 1px;">-->
<!--                                                              <span>-->
<!--                                                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                                                    <line x1="10" y1="4" x2="10" y2="12" stroke="#EF4E4E" stroke-width="2"/>-->
<!--                                                                    <line x1="10" y1="13.5" x2="10" y2="16" stroke="#EF4E4E" stroke-width="2"/>-->
<!--                                                                    <circle cx="10" cy="10" r="9" stroke="#EF4E4E" stroke-width="2"/>-->
<!--                                                                  </svg>-->
<!--                                                              </span>-->
<!--                        <span style="margin-left: 1px;">-->
<!--                                                                  Скоро закінчується-->
<!--                                                              </span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash;   v-if="order.manualTypeId && (order.payments.length === 0 || order.payments.some(item => item.invoice.receipt === null))" &ndash;&gt;-->
<!--                    <file-input class="option-value w-100 download-receipt" :http-request="(options) => uploadReceipt(options, order)" @remove-file="receiptLoaded = false" @upload-success="$emit('init-orders-list');">-->
<!--                      <template #button>-->
<!--                        <div class="payment-status mt-1">&lt;!&ndash;  h-auto d-inline-block p-1 &ndash;&gt;-->
<!--                          <span style="line-height: 22px">Завантажити квитанцію</span>-->
<!--                        </div>-->
<!--                      </template>-->
<!--                    </file-input>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-6 half-block">-->
<!--                <div class="info-block">-->
<!--                &lt;!&ndash;                                        <div class="d-flex">&ndash;&gt;-->
<!--                &lt;!&ndash;                                            <span class="sub-option-title">Точка продажу:</span>&ndash;&gt;-->
<!--                &lt;!&ndash;                                            <span data-toggle="tooltip" data-placement="bottom" :title="showNameInsured(order)" class="option-value">&ndash;&gt;-->
<!--                &lt;!&ndash;                                              {{ showNameInsured(order) }}&ndash;&gt;-->
<!--                &lt;!&ndash;                                            </span>&ndash;&gt;-->
<!--                &lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--                <div class="option-title">Точка продажу:</div>-->
<!--                <div class="option-value" v-if="showInsuredName(order) && showInsuredSurname(order)">-->
<!--                  <div class="option-value" v-if="showInsuredSurname(order)">-->
<!--                    {{ showInsuredSurname(order) }}-->
<!--                  </div>-->
<!--                  <div class="option-value" v-if="showInsuredName(order)">-->
<!--                    {{ showInsuredName(order) }}-->
<!--                  </div>-->
<!--                  <div class="option-value" v-if="showInsuredPatronymic(order)">-->
<!--                    {{ showInsuredPatronymic(order) }}-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div v-else class="option-value" data-toggle="tooltip" data-placement="bottom" :title="showNameInsured(order)">-->
<!--                  {{ showNameInsured(order) }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--        </div>-->

        <div class="row-mobile">

            <div class="col-6 half-block">
              <div  class="info-block options-block" style="margin-top: auto;color: #999DA6;">

                <div class="options-btn">
                  <div v-if="loadMoreOptions[order.id + order.typeId] === true"
                       class="option-loader spinner-border"
                       style="height: 20px; width: 20px; margin-top: 11px;"
                       role="status">
                  </div>
                  <more-options style="padding-top: 5px"
                                v-else :status-order="showStatusId(order)"
                                @download-draft="downloadDraft(order)"
                                @download-contract="takeContractCompact(order, 2)"
                                @show-order="goToOrderInfo(order)"
                                @proceed-order="declare(order)"
                                @confirm-order="declare(order,false,false,2)"
                                @open-mtsbu-link="openMtsbuLink(order)"
                                @get-all-payment-ways="showAllOrderPaymentWays(order)"
                                @get-payment-invoice="getPaymentInvoice(order)"
                                @get-instant-loan="getInstantLoan(order)"
                                :is-exist-mtsbu-link="showMtsbuLink(order)"
                                @copy-order="copy(order)"
                                :order="order"
                                :order-type="order.typeId"
                                :data-contract-extra-files="order.contract.extraFiles"
                  >
                  </more-options>
                </div>
              </div>
            </div>
        </div>

      <!--      <div class="col-6 half-block">-->
      <!--        <div class="info-block">-->
      <!--          <div class="option-title">СК:</div>-->
      <!--          <div class="option-value">-->
      <!--            <ellipsis :data="order.companyInfo.name"></ellipsis>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

        <div v-if="order.typeId === 1 && showDgoPrice(order)" class="row-mobile additional-product">
            <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Тип поліса</div>
                  <div class="option-value">ДЦВ</div>
                </div>
            </div>
            <div class="col-6 half-block">
                <div class="info-block">
                <div class="option-title">Вартість, грн</div>
                <div class="sub-options">
                  <div v-if="showDgoPrice(order)">
                    <span class="sub-option-title">Первісна:</span>
                    <span class="option-value">{{ showDgoPrice(order) }}</span>
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div v-if="order.typeId === 1 && showAutolawyerPrice(order)" class="row-mobile">
          <div class="col-6 half-block">
            <div class="info-block">
              <div class="option-title">Тип поліса</div>
              <div class="option-value">Автоюрист</div>
            </div>
          </div>
          <div class="col-6 half-block">
            <div class="info-block">
              <div class="option-title">Вартість, грн</div>
              <div class="sub-options">
                <div v-if="showAutolawyerPrice(order)">
                  <span class="sub-option-title">Первісна:</span>
                  <span class="option-value">{{ showAutolawyerPrice(order) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import ClickOutside from 'vue-click-outside'
import { ClientInfo, MoreOptions } from './../components';
import { customerMixin, HistoryMixin, orderMixin, userMixin } from '@/mixin';
import displaySettings from '@/mixin/displaySettings';

export default {
      name: 'OrderCardCompact',
      components: {
        MoreOptions,
        ClientInfo,
      },
      mixins: [orderMixin, customerMixin, HistoryMixin, displaySettings, userMixin],
      directives: { ClickOutside },
      props: {
            order: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            showActsColumnStatus: {
              type: Boolean,
              default: () => {
                return false;
              }
            },
            margeActsList: {
              type: Object,
              default: () => {
                return {};
              }
            },
            listQuery: {
              type: Object,
              default: () => {
                return {};
              }
            },
            loadMoreOptions: {
              type: Object,
              default: () => {
                return {};
              }
            },
        },
        data: function () {
            return {
                condition: {
                    isShow: false,
                },
            }
        },
        computed: {
          orderTypes: function () {
            return this.$store.getters.ORDER_TYPES;
          },
        },
        methods: {
            hide: function () {
                return this.condition.isShow = false;
            },
            handle: function () {
                return this.condition.isShow = ! this.condition.isShow
            },
            aktsToggleCompact(order,$event) {
              this.$emit('acts-toggle', order,$event);
            },
            takeContractCompact(order, orderType) {
              this.$emit('take-contract', order, orderType);
            }
        }
    }
</script>

<style lang="scss" scoped>



</style>
